import { render, staticRenderFns } from "./famely.vue?vue&type=template&id=c7b6a186&"
import script from "./famely.vue?vue&type=script&lang=js&"
export * from "./famely.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports